module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail3.06a3d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail3.jpg
// module id = prbh
// module chunks = 5